import type {
  InsightsOverviewQuery,
  InsightsOverviewResponse,
} from "@nlc/shared-types";
import type { UseQueryResult } from "@tanstack/react-query";

import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { socialPublishingKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

async function getInsightsOverview(
  query: InsightsOverviewQuery,
): Promise<InsightsOverviewResponse> {
  return apiClient
    .url("/social-publishing/insights/overview")
    .query(
      Object.fromEntries(
        Object.entries(query).filter(([, value]) => value !== undefined),
      ),
    )
    .get()
    .json();
}

export function useInsightsOverview(
  query: InsightsOverviewQuery,
): UseQueryResult<InsightsOverviewResponse, Error> {
  return useQuery({
    placeholderData: keepPreviousData,
    queryFn: () => getInsightsOverview(query),
    queryKey: socialPublishingKeys.insightsOverview(query),
  });
}
